module.exports = __webpack_public_path__ + "assets/images/invisible-asia/8-philippines.jpg?v=7332c6d3";